export default {"src":"/_next/static/media/Active.29b6ff15.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};